import { Col, DatePicker, Form } from "antd";
import dayjs from "dayjs";

const rules = {
  required: [{ required: true, message: "Campo obrigatório!" }],
};

const DateQuestion = ({ loading, obrigatorio, questao, id, defaultValue = "" }) => {
  return (
    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
      <Form.Item
        initialValue={defaultValue && dayjs(defaultValue).isValid() && dayjs(defaultValue)}
        name={["date", `${id}`]}
        label={<strong>{questao}</strong>}
        rules={obrigatorio === 1 ? rules.required : null}
        getValueFromEvent={(e) => e?.format("YYYY-MM-DD")}
        getValueProps={(e) => ({
          value: e ? dayjs(e) : "",
        })}>
        <DatePicker format="DD/MM/YYYY" disabled={loading} style={{ width: "100%" }} size="large" />
      </Form.Item>
    </Col>
  );
};

export { DateQuestion };
